import { render } from "./HeaderSidebar.vue?vue&type=template&id=70daf702"
import script from "./HeaderSidebar.vue?vue&type=script&lang=js"
export * from "./HeaderSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/navigation/HeaderSidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70daf702"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70daf702', __exports__)) {
    console.log('reload')
    api.reload('70daf702', __exports__)
  }
  
  module.hot.accept("./HeaderSidebar.vue?vue&type=template&id=70daf702", () => {
    console.log('re-render')
    api.rerender('70daf702', render)
  })

}


export default __exports__